export default function HeritageSection() {
  return (
    <section className="relative bg-background-50 overflow-hidden">
      {/* Background image - DSC2549 from original */}
      <div className="absolute inset-0">
        <img
                  src="/images/k1.jpg"
          alt=""
          className="w-full h-full object-cover opacity-[0.12]"
        />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 py-16 md:py-24 text-center">
        {/* Headline */}
        <h2 className="font-heading text-3xl sm:text-4xl md:text-[42px] text-primary-700 tracking-[0.2em] mb-4 md:mb-6">
          TRADITION. PRIDE. EXCELLENCE.
        </h2>

        {/* Subheadline */}
        <p className="text-[10px] md:text-[11px] text-primary-600 tracking-[0.18em] uppercase max-w-3xl mx-auto mb-6 md:mb-8 leading-relaxed font-medium">
          FROM NEW BEDFORD TO FALL RIVER, BRANDON VIEIRA AND HIS FAMILY HAVE BEEN IN THE SEAFOOD BUSINESS FOR THREE GENERATIONS, BRINGING UNMATCHED EXPERTISE TO EVERY CATCH.
        </p>

        {/* Divider */}
        <div className="w-24 h-0.5 bg-primary-400 mx-auto mb-6 md:mb-8" />

        {/* Paragraphs */}
        <div className="max-w-3xl mx-auto space-y-4">
          <p className="text-[13px] md:text-sm text-foreground-700 leading-relaxed">
            The FKS commitment to being &ldquo;America&rsquo;s One-Stop-Shop for Seafood&rdquo; is unrelenting proof that we will do whatever it takes to meet and exceed the demands of our cherished customers.
          </p>
          <p className="text-[13px] md:text-sm text-foreground-700 leading-relaxed">
            It is our mission at Finest Kind Seafood LLC to provide &ldquo;All the Best&rdquo; seafood &amp; shellfish on the market, day-in and day-out. Our fresh seafood is guaranteed to provide our valued customers the quality they expect, while our volume buying power is guaranteed to ensure our customers the sharp wholesale seafood prices they appreciate.
          </p>
        </div>
      </div>
    </section>
  );
}